import React from 'react';
import {
  PageContainer,
  HeroSection,
  HeroTitle,
  ContentSection,
  ParallaxDivider,        
  TitleContainer,  
  Title,
  ValuesSection,
  SectionTitle,
  ValuesGrid,
  ValueCard,
  ValueTitle,
  ValueText,
  PartnersSection,
  PartnersGrid,
  LeftColumn,
  RightColumn,
  PartnerTitle,
  FeatureList,
  FeatureItem   
} from './style'; 


const nossosValores = [
  {
    title: "SUSTENTABILIDADE",
    text: "Promovemos práticas responsáveis em toda a operação, impulsionando o crescimento da energia limpa."
  },
  {
    title: "INOVAÇÃO",
    text: "Estamos sempre em busca de novas soluções e tecnologias que agreguem valor aos integradores."
  },
  {
    title: "EXCELÊNCIA",
    text: "Compromisso com a entrega de qualidade superior em produtos, serviços e atendimento."
  },
  {
    title: "RESPONSABILIDADE SOCIAL",
    text: "Democratizamos o acesso à energia renovável e apoiamos projetos sociais em diversas regiões."
  },
  {
    title: "TRANSPARÊNCIA E ÉTICA",
    text: "Atuamos com total integridade, construindo relações sólidas com base em respeito e confiança."
  },
  {
    title: "FOCO NO CLIENTE",
    text: "Entendemos as necessidades reais dos nossos clientes e oferecemos soluções ágeis e humanizadas."
  }
];

const diferenciaisParceiro = [
  "Plataforma 100% digital com usabilidade otimizada.",
  "Integração com +20 distribuidores parceiros em tempo real.",
  "Atendimento humanizado, rápido e resolutivo.",
  "Comparador inteligente de preços e condições.",
  "Suporte técnico especializado para integradores.",
  "Ferramentas como o Renô Adviser, para ajudar em projetos negados por inversão de fluxo.",
  "Pós-venda ativo e acompanhamento completo de ponta a ponta."
];

function QuemSomos() {
  return (
    <>
      <PageContainer>
        <HeroSection>
          <HeroTitle>QUEM SOMOS</HeroTitle>
        </HeroSection>

        <ContentSection>
          <p>
            A Renovera nasceu para transformar a forma como integradores e distribuidores fazem negócios no mercado de energia solar. Unimos tecnologia, agilidade e atendimento humanizado para oferecer uma experiência de compra simples, direta e segura.
          </p>
          <p>
            Com uma plataforma 100% digital e um time especializado, conectamos as melhores oportunidades do mercado, simplificando processos e gerando valor para todos os envolvidos. Nosso objetivo é impulsionar negócios, fortalecer parcerias e contribuir ativamente para o crescimento sustentável do setor fotovoltaico no Brasil.
          </p>
      </ContentSection>

       
        <ParallaxDivider>
          <TitleContainer align="right">
            <Title>Nossa Missão</Title>
          </TitleContainer>
        </ParallaxDivider>

       
        <ContentSection>
          <p>
            Oferecer soluções inovadoras e personalizadas no mercado de energia renovável, atuando como ponte estratégica entre distribuidores e integradores. Nosso propósito é simplificar processos, ampliar o acesso à energia limpa e garantir o sucesso dos nossos parceiros.
          </p>
        </ContentSection>

          <ParallaxDivider>
          <TitleContainer align="right">
            <Title>Nossa visão</Title>
          </TitleContainer>
        </ParallaxDivider>

       
       
        <ContentSection>
          <p>
           Ser reconhecida como a principal plataforma digital de intermediação no mercado solar, referência em eficiência,
           inovção e geração de negócios sustentáveis, contribnuindo para a construção de um mercado fotovoltaico mais competitivo no Brasil.
          </p>
        </ContentSection>

         <ParallaxDivider>
          <TitleContainer align="right">
            <Title>Nossos Valores</Title>
          </TitleContainer>
        </ParallaxDivider>

         <ValuesSection>
          <ValuesGrid>
            {nossosValores.map((valor, index) => (
              <ValueCard key={index}>
                <ValueTitle>{valor.title}</ValueTitle>
                <ValueText>{valor.text}</ValueText>
              </ValueCard>
            ))}
          </ValuesGrid>
        </ValuesSection>

        <PartnersSection>
          <PartnersGrid>
            <LeftColumn>
              <PartnerTitle>Porque ser parceiro</PartnerTitle>
                <img src="/logo-renovera-2.png" alt="Logo Renovera" />
            </LeftColumn>
            <RightColumn>
              <FeatureList>
                {diferenciaisParceiro.map((diferencial, index) => (
                  <FeatureItem key={index}>
                    <img src="/icone/icone-certo.png" alt="Ícone de check" />
                    <span>{diferencial}</span>
                  </FeatureItem>
                ))}
              </FeatureList>
            </RightColumn>
          </PartnersGrid>
        </PartnersSection>

        

      </PageContainer>
    </>
  );
}

export default QuemSomos;